import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import products from "../../../Data/products.json";
import units from "../../../Data/units.json";
import categories from "../../../Data/category.json";
import brands from "../../../Data/brands.json";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import {
  get_all_products_reports,
  get_fast_moving_products_reports,
  get_products_ageing_reports,
} from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import moment from "moment";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { registerCairoFont } from "../cairo-font";
import ScrollWrapper from "../../../Componets/ScrollWrapper";

const ProductAgeingReports = () => {
  let componentRef = useRef();
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const [total, setTotal] = useState();
  const [role, setRole] = useState("");

  const headers = {
    name: "Products Ageing",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        className: "w-[200px]",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Name (A-Z)" },
          { value: 1, label: "Name (Z-A)" },
          { value: 2, label: "Days (Low)" },
          { value: 3, label: "Days (High)" },
          { value: 4, label: "Purchase Qty (Low)" },
          { value: 5, label: "Purchase Qty (High)" },
          { value: 6, label: "Current Stock (Low)" },
          { value: 7, label: "Current Stock (High)" },
          { value: 8, label: "Total Sold (Low)" },
          { value: 9, label: "Total Sold (High)" },
          { value: 10, label: "Movement%  (Low)" },
          { value: 11, label: "Movement% (High)" },
        ],
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        className: "w-[200px]",
        value: null,
        options: null,
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
    navigate: {
      tabs: [
        {
          name: "Reports",
          path: "/app/reports",
        },
        {
          name: "Product Ageing",
          path: ""
        }
      ],
      total: [
        { value: 0, label: "Total" },
        { value: 0, label: "Active" },
        { value: 0, label: "Inactive" },
      ],
    },
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        unit: tabledata?.unit,
        category: tabledata?.category,
        brand: tabledata?.brand,
        type: tabledata?.type,
        status: tabledata?.status,
        date: tabledata?.date,
        branch: tabledata?.branch,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      // const products = await get_all_products(data);
      const products = await get_products_ageing_reports(data);

      if (products?.status) {
        setBody(products?.data?.allProductAgeing);
        setRole(products?.data?.role);
        // setTotal(products?.data);

        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  const downloadCSV = () => {
    console.log("Download CSV clicked");
    console.log("Body data:", body);

    if (!body || body.length === 0) {
      console.log("No data available for download");
      toast.error("No data available to download");
      return;
    }

    try {
      const header = ["S.No", "Name", "Batch", "Purchase Date", "Days", "Purchase Qty", "Current Stock", "Total Sold", "Movement"];

      const rows = body?.map((item, index) => {
        const row = [
          index + 1,
          item?.name || "-",
          item?.batch ? `#BATCH-${item.batch}` : "-",
          formatDate(item?.purchase_date),
          item?.days ?? "-",
          item?.purchase_stock?.toFixed?.(3) || 0,
          item?.current_stock?.toFixed?.(3) || 0,
          item?.total_sold?.toFixed?.(3) || 0,
          item?.movement_percent?.toFixed?.(3) ? `${item.movement_percent.toFixed(3)}%` : "0%",
        ];
        return row;
      });

      const csvContent = [header, ...rows]
        .map(row => row.map(field => `"${field}"`).join(","))
        .join("\n");

      const encoder = new TextEncoder();
      const encodedContent = encoder.encode('\uFEFF' + csvContent);

      const blob = new Blob([encodedContent], { type: 'text/csv;charset=utf-8' });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `Product_Ageing_Report_${new Date().toLocaleDateString().replace(/\//g, '_')}.csv`);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Error generating CSV:", error);
      toast.error("Failed to generate CSV file");
    }
  };

  const downloadPDF = () => {
    if (!body || body.length === 0) return;

    const doc = new jsPDF();
    registerCairoFont(doc);

    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFont("Cairo-Bold", "bold");

    doc.setFontSize(18);
    doc.text("Product Ageing Report", pageWidth / 2, 18, { align: "center" });

    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB");
    const formattedTime = now.toLocaleTimeString();
    doc.setFontSize(10);
    doc.text(`Downloaded on: ${formattedDate} ${formattedTime}`, pageWidth / 2, 26, { align: "center" });

    const tableRows = body.map((item, index) => [
      index + 1,
      item?.name || "-",
      item?.batch ? `#BATCH-${item.batch}` : "-",
      formatDate(item?.purchase_date),
      item?.days ?? "-",
      item?.purchase_stock?.toFixed?.(3) || 0,
      item?.current_stock?.toFixed?.(3) || 0,
      item?.total_sold?.toFixed?.(3) || 0,
      item?.movement_percent?.toFixed?.(3) ? `${item.movement_percent.toFixed(3)}%` : "0%",
    ]);

    autoTable(doc, {
      startY: 32,
      head: [["S.No", "Name", "Batch", "Purchase Date", "Days", "Purchase Qty", "Current Stock", "Total Sold", "Movement"]],
      body: tableRows,
      styles: {
        font: "Cairo",
        textColor: [0, 0, 0],
        lineColor: [7, 181, 83],
        lineWidth: 0.2
      },
      headStyles: {
        font: "Cairo",
        fontStyle: "bold",
        fillColor: false,
        lineColor: [7, 181, 83],
        lineWidth: 0.6
      },
    });

    doc.save(`Product_Ageing_Report_${formattedDate}.pdf`);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!role) return;

    let updatedHeader = { ...headers };

    if (role !== "SUPERADMIN") {
      updatedHeader.components = updatedHeader.components.filter(
        (item) => item.name !== "branch"
      );
    }

    setHeader(updatedHeader);
  }, [role]);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>

        <div className="text-right flex gap-3 justify-end mt-4 ">
          <Button
            className="text-medium form-save-button"
            type="primary"
            onClick={downloadCSV}
          >
            Download CSV
          </Button>

          <ReactToPrint
            trigger={() => (

              <Button
                className="text-medium form-save-button"
                type="primary"
              >
                Download PDF
              </Button>
            )}
            content={() => componentRef}
            pageStyle={`
                                    @page {
                                      size: landscape;
                                      margin: 10mm;
                                    }
                      
                                    @media print {
                                      tfoot {
                                        position: static !important;
                                        bottom: auto !important;
                                      }
                                      thead { 
                                        display: table-header-group !important;
                                      }
                                      tfoot {
                                        display: table-row-group !important;
                                      }
                                    }
                      
                                      table {
                                      border-collapse: collapse;
                                      width: 100%;
                                    }
                                    th, td {
                                      border: 1px solid #ddd;
                                      padding: 6px;
                                    }
                                    th {
                                      background-color: #f4f4f4;
                                    }
                                  `}
          />
        </div>
        <ScrollWrapper>
          <div
            className="max-h-[70vh] overflow-y-auto scrollbar-hide remove-scroll-limit"
            ref={(el) => (componentRef = el)}
          >
            <table className="w-full bg-white">
              <thead className="text-gray-500 sticky top-0 bg-white z-10">
                <tr className="text-sm">
                  <td className="border p-4">S.No</td>
                  <td className="border p-4">Name</td>
                  <td className="border p-4">Batch</td>
                  <td className="border p-4">Purchase&nbsp;date</td>
                  <td className="border p-4">Days</td>
                  <td className="border p-4">Purchase&nbsp;Qty</td>
                  <td className="border p-4">Current&nbsp;Stock</td>
                  <td className="border p-4">Total&nbsp;Sold</td>
                  <td className="border p-4">Movement</td>
                </tr>
              </thead>
              <tbody>
                {body?.map((value, index) => {
                  return (
                    <tr className="text-xs">
                      <td className="border p-4">{index + 1}</td>
                      <td className="border p-4">{value?.name}</td>
                      <td className="border p-4">{value?.batch}</td>
                      <td className="border p-4">
                        {moment?.(value?.purchase_date)?.format("DD/MM/YYYY")}
                      </td>
                      <td className="border p-4">
                        {value?.days ? value?.days : "0"}
                      </td>
                      <td className="border p-4">
                        {value?.purchase_stock
                          ? Number.isInteger(value?.purchase_stock)
                            ? parseFloat?.(value?.purchase_stock || 0)
                            : parseFloat?.(value?.purchase_stock || 0)?.toFixed(3)
                          : "0"}
                      </td>
                      <td className="border p-4">
                        {value?.current_stock
                          ? Number.isInteger(value?.current_stock)
                            ? parseFloat?.(value?.current_stock || 0)
                            : parseFloat?.(value?.current_stock || 0)?.toFixed(3)
                          : "0"}
                      </td>
                      <td className="border p-4">
                        {value?.total_sold
                          ? Number.isInteger(value?.total_sold)
                            ? parseFloat?.(value?.total_sold || 0)
                            : parseFloat?.(value?.total_sold || 0)?.toFixed(3)
                          : "0"}
                      </td>
                      <td className="border p-4">
                        {value?.movement_percent
                          ? value?.movement_percent + "%"
                          : "0%"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>

              <tfoot className="sticky bottom-0 bg-white z-10">
                <tr className="text-sm font-medium">
                  <td className="border p-4 text-medium">TOTAL</td>
                  <td className="border p-4"></td>
                  <td className="border p-4 text-medium"></td>
                  <td className="border p-4 text-medium"></td>
                  <td className="border p-4 text-medium"></td>
                  <td className="border p-4 text-medium"></td>
                  <td className="border p-4 text-medium"></td>
                  <td className="border p-4 text-medium"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default ProductAgeingReports;